/**
 * Design Tokens - Apple-Clean Aesthetic
 * 
 * A minimal, timeless design system inspired by Apple's design language.
 * Focuses on generous whitespace, subtle shadows, and restrained color.
 */

export const colors = {
  // Backgrounds
  background: '#FFFFFF',
  surface: '#F5F5F7',
  surfaceHover: '#EBEBED',
  
  // Borders
  border: '#E5E5E7',
  borderLight: '#F0F0F2',
  
  // Sidebar
  sidebar: '#1D1D1F',
  sidebarHover: '#2D2D2F',
  sidebarActive: 'rgba(255, 255, 255, 0.12)',
  
  // Primary (Apple Blue)
  primary: '#0071E3',
  primaryHover: '#0077ED',
  primaryActive: '#006EDB',
  
  // Text
  textPrimary: '#1D1D1F',
  textSecondary: '#86868B',
  textTertiary: '#AEAEB2',
  textInverse: '#FFFFFF',
  
  // Semantic
  success: '#34C759',
  successBg: '#E8F9ED',
  warning: '#FF9500',
  warningBg: '#FFF4E5',
  error: '#FF3B30',
  errorBg: '#FFEBE9',
  
  // Platform colors
  platform: {
    getyourguide: '#FF5533',
    viator: '#00AA6C',
    tripadvisor: '#34E0A1',
  },
} as const;

export const shadows = {
  sm: '0 1px 2px rgba(0, 0, 0, 0.04)',
  md: '0 4px 12px rgba(0, 0, 0, 0.08)',
  lg: '0 12px 40px rgba(0, 0, 0, 0.12)',
  // Focused state
  focus: '0 0 0 4px rgba(0, 113, 227, 0.24)',
} as const;

export const spacing = {
  0: '0',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '20px',
  6: '24px',
  8: '32px',
  10: '40px',
  12: '48px',
  16: '64px',
  20: '80px',
  24: '96px',
} as const;

export const radii = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  full: '9999px',
} as const;

export const typography = {
  fonts: {
    heading: 'inherit',
    body: 'inherit',
  },
  sizes: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '32px',
    '4xl': '40px',
    '5xl': '48px',
  },
  weights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  letterSpacing: {
    tighter: '-0.02em',
    tight: '-0.01em',
    normal: '0',
    wide: '0.02em',
  },
} as const;

export const transitions = {
  fast: '150ms ease',
  normal: '200ms ease',
  slow: '300ms ease',
} as const;



